import { Button } from 'fluxo-ui';
import { EyeIcon } from 'fluxo-ui/icons';

import { LiveQuizPublicQuestion } from '../../../types/index.ts';

import QuestionTimer from './QuestionTimer';

interface HostQuestionPanelProps {
    question: LiveQuizPublicQuestion;
    secondsRemaining: number;
    progress: number;
    responded: number;
    totalParticipants: number;
    onReveal: () => void;
}

const HostQuestionPanel: React.FC<HostQuestionPanelProps> = ({
    question,
    secondsRemaining,
    progress,
    responded,
    totalParticipants,
    onReveal,
}) => (
    <section className="rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5 sm:p-6">
        <div className="flex items-start justify-between gap-5">
            <div className="min-w-0">
                <h2 className="text-xl sm:text-2xl font-semibold leading-snug text-slate-900 dark:text-white">
                    {question.text || question.title}
                </h2>
                <p className="mt-3 text-sm text-slate-500 dark:text-slate-400 tabular-nums">
                    {responded} of {totalParticipants} answered
                </p>
                <div className="mt-2 h-1.5 w-full max-w-xs rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
                    <div
                        className="h-full rounded-full bg-teal-500 transition-[width] duration-300"
                        style={{ width: `${totalParticipants > 0 ? (responded / totalParticipants) * 100 : 0}%` }}
                    />
                </div>
            </div>
            <QuestionTimer secondsRemaining={secondsRemaining} progress={progress} />
        </div>

        <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2">
            {question.options.map((option, index) => (
                <li
                    key={option.id}
                    className="flex items-center gap-2.5 rounded border border-slate-200 dark:border-slate-800 px-3 py-2.5 text-sm text-slate-700 dark:text-slate-300"
                >
                    <span className="grid place-items-center w-6 h-6 shrink-0 rounded bg-slate-100 dark:bg-slate-800 text-xs font-bold">
                        {String.fromCharCode(65 + index)}
                    </span>
                    <span className="min-w-0 truncate">{option.text}</span>
                </li>
            ))}
        </ul>

        <div className="mt-5 flex justify-end">
            <Button label="Reveal answer now" leftIcon={EyeIcon} variant="default" size="sm" onClick={onReveal} />
        </div>
    </section>
);

export default HostQuestionPanel;
